import currency from 'currency.js'

const options = { symbol: '£', formatWithSymbol: true }

export const GBP = value => currency(value, options)

// A price as the rest of the site writes it: "£69", not "£69.00", and the
// pence only when there are some ("£12.50"). currency.js 1.x has no format
// hook, so the booking screen and checkout format through this rather than
// `.format()`. Takes a currency object or anything GBP() accepts.
export const money = value => {
  const amount = value && typeof value.format === 'function' ? value : GBP(value)
  const text = amount.format(true)
  return text.endsWith('.00') ? text.slice(0, -3) : text
}
